// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Hr4g","content":"styles_content__3QLDE"};